import { EnvironmentType, ExceptionCode } from "@/enums/enums";
import { i18n } from "@/i18n";

export function NewObject(obj: any) {
  if (obj == "") {
    return "";
  } else {
    return JSON.parse(JSON.stringify(obj));
  }
}
export function CheckIsDevelop() {
  return process.env.VUE_APP_TYPE_ENV <= EnvironmentType.SIT;
}
export function GetMessageExceptionCode(exception: any, text: any = "") {
  let message: any = "";
  switch (exception.code) {
    case ExceptionCode.CodeDuplicated:
      message = i18n.t("Exceptions_Notification.CodeDuplicated", { text: text });
      break;
    case ExceptionCode.CodeIsEmpty:
      message = i18n.t("Exceptions_Notification.CodeIsEmpty", { text: text });
      break;
    case ExceptionCode.IsHaveEmployee:
      message = i18n.t("Exceptions_Notification.IsHaveEmployee");
      break;
    case ExceptionCode.IsHaveSalaryEmployee:
      message = i18n.t("Exceptions_Notification.IsHaveSalaryEmployee");
      break;
    default:
      message = i18n.t("Something_Wrong", { errorMessage: exception.code });
      break;
  }
  return message;
}
export function CheckIsMUZE() {
  return process.env.VUE_APP_Is_MUZE == 1;
}
export function DecodeJwtResponse(credential: any) {
  return JSON.parse(atob(credential.split(".")[1]).toString());
}
